export default __webpack_public_path__ + "static/media/development_to_mass_production_support_1.da39af0c.png";